import React, {useEffect, useRef, useState} from 'react';
import {
    Button,
    Checkbox,
    Confirm,
    Container,
    Dropdown,
    Form,
    Grid,
    Header,
    Input,
    Label,
    Message,
    Modal,
    Segment
} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import './App.css'; // Import the CSS file
import ModeConfigWidget from './ModeConfigWidget.js'; // Make sure to provide the correct path to the ModeConfigWidget file
import ConfigPage from './ConfigPage';


function App() {

    const [adminCfg, setAdminCfg] = useState(() => {
        return {
            core: {
                evalTickInterval: 0,
            },
            playerQueueCfg: {
                queueProcessBatchSize: 0,
                queueTimeOut: 0,
            },
            modeCfg: GetDefaultMMModeConfig()
        }
    });

    function GetDefaultMMModeConfig() {
        return {
            miniBR: GetDefaultMiniBRConfig(),
            fullBR: GetDefaultBRConfig(),
            tutorialBR: GetDefaultTutorialBRConfig(),
            tdm: GetDefaultTDMConfig(),
            miniTDM: GetDefaultMiniTDMConfig(),
            lowGravity: GetDefaultLowGravityConfig(),
            deadeyeDM: GetDefaultDeadeyeDMConfig(),
            controlPoints: GetDefaultControlPointsConfig(),
            ftueControlPoints: GetDefaultFtueControlPointsConfig(),
            football: GetDefaultFootballConfig(),
            gunGame: GetDefaultGunGameConfig(),
            vip: GetDefaultVipConfig(),
            showdown: GetDefaultShowdownConfig()
        };
    }

    function GetDefaultMiniBRConfig() {
        return {
            solo: {
                sessionCfg: GetDefaultMiniBRSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            },
            duo: {
                sessionCfg: GetDefaultMiniBRSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            },
            quad: {
                sessionCfg: GetDefaultMiniBRSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            },
        };
    }

    function GetDefaultBRConfig() {
        return {
            solo: {
                sessionCfg: GetDefaultBRSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            },
            duo: {
                sessionCfg: GetDefaultBRSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            },
            quad: {
                sessionCfg: GetDefaultBRSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            },
        };
    }

    function GetDefaultTutorialBRConfig() {
        return {
            solo: {
                sessionCfg: GetDefaultTutorialBRSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            },
            duo: {
                sessionCfg: GetDefaultTutorialBRSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            },
            quad: {
                sessionCfg: GetDefaultTutorialBRSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            },
        };
    }

    function GetDefaultTDMConfig() {
        return {
            quad: {
                sessionCfg: GetDefaultTDMQuadSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            }
        }
    }

    function GetDefaultMiniTDMConfig() {
        return {
            duo: {
                sessionCfg: GetDefaultMiniTDMDuoSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            }
        }
    }

    function GetDefaultLowGravityConfig() {
        return {
            solo: {
                sessionCfg: GetDefaultLowGravitySoloSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            }
        }
    }

    function GetDefaultDeadeyeDMConfig() {
        return {
            solo: {
                sessionCfg: GetDefaultDeadeyeDMSoloSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            }
        }
    }

    function GetDefaultControlPointsConfig() {
        return {
            quad: {
                sessionCfg: GetDefaultSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            }
        }
    }

    function GetDefaultFtueControlPointsConfig() {
        return {
            quad: {
                sessionCfg: GetDefaultSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            }
        }
    }

    function GetDefaultFootballConfig() {
        return {
            quad: {
                sessionCfg: GetDefaultSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            }
        }
    }

    function GetDefaultGunGameConfig() {
        return {
            quad: {
                sessionCfg: GetDefaultSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            }
        }
    }

    function GetDefaultVipConfig() {
        return {
            quad: {
                sessionCfg: GetDefaultSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            }
        }
    }

    function GetDefaultShowdownConfig() {
        return {
            solo: {
                sessionCfg: GetDefaultSessionConfig(),
                serverCfg: GetDefaultServerConfig(),
                mmrConfig: GetDefaultMmrConfig(),
            }
        }
    }

    function GetDefaultSessionConfig() {
        return {
            minPlayers: 20,
            maxPlayers: 20,
            fillupTimeOut: 60.0,
            allocationTimeOut: 15.0,
            playingClearOut: 300,
            expiredClearOut: 300,
            waitingTimeThreshold: 5,
        };
    }

    function GetDefaultServerConfig() {
        return {
            readyTimeOut: 60,
            allocatedTimeOut: 60,
            playerThreshold: 1,
            playingClearOut: 60,
            expiredClearOut: 60,
            minRemainingGameTimeNeeded: 300,
            scoreThreshold: 30,
            waitTime: 10,
        };
    }

    function GetDefaultMmrConfig() {
        return {
            isMmrEnabled: true,
            controlledValue: 5,
            ranges: [
                {min: 0, max: 15},
                {min: 16, max: 10000}
            ]
        }
    }

    function GetDefaultBRSessionConfig() {
        return {
            minPlayers: 10,
            maxPlayers: 60,
            fillupTimeOut: 60.0,
            allocationTimeOut: 15.0,
            playingClearOut: 300,
            expiredClearOut: 300,
        };
    }

    function GetDefaultMiniBRSessionConfig() {
        return {
            minPlayers: 5,
            maxPlayers: 8,
            fillupTimeOut: 60.0,
            allocationTimeOut: 15.0,
            playingClearOut: 300,
            expiredClearOut: 300,
        };
    }

    function GetDefaultTutorialBRSessionConfig() {
        return {
            minPlayers: 1,
            maxPlayers: 4,
            fillupTimeOut: 60.0,
            allocationTimeOut: 15.0,
            playingClearOut: 300,
            expiredClearOut: 300,
        };
    }

    function GetDefaultTDMQuadSessionConfig() {
        return {
            minPlayers: 4,
            maxPlayers: 8,
            fillupTimeOut: 60.0,
            allocationTimeOut: 15.0,
            playingClearOut: 300,
            expiredClearOut: 300,
            waitingTimeThreshold: 5,
            isQuickJoinDisabled: false,
        };
    }

    function GetDefaultMiniTDMDuoSessionConfig() {
        return {
            minPlayers: 4,
            maxPlayers: 4,
            fillupTimeOut: 60.0,
            allocationTimeOut: 15.0,
            playingClearOut: 300,
            expiredClearOut: 300,
            waitingTimeThreshold: 5,
            isQuickJoinDisabled: false,
        };
    }

    function GetDefaultLowGravitySoloSessionConfig() {
        return {
            minPlayers: 20,
            maxPlayers: 20,
            fillupTimeOut: 60.0,
            allocationTimeOut: 15.0,
            playingClearOut: 300,
            expiredClearOut: 300,
            waitingTimeThreshold: 5,
            isQuickJoinDisabled: false,
        };
    }

    function GetDefaultDeadeyeDMSoloSessionConfig() {
        return {
            minPlayers: 20,
            maxPlayers: 20,
            fillupTimeOut: 60.0,
            allocationTimeOut: 15.0,
            playingClearOut: 300,
            expiredClearOut: 300,
            waitingTimeThreshold: 5,
        };
    }

    const appVersion = '0.1.13';
    const gameModes = [
        {key: 'All', text: 'All', value: -1},
        {key: 'BR', text: 'BR', value: 0},
        {key: 'TDM', text: 'TDM', value: 3},
        {key: 'MiniTDM', text: 'MiniTDM', value: 4},
        {key: 'LowGravity', text: 'LowGravity', value: 9},
        {key: 'DeadeyeDM', text: 'DeadeyeDM', value: 10},
        {key: 'ControlPoints', text: 'ControlPoints', value: 11},
        {key: 'GunGame', text: 'GunGame', value: 12},
        {key: 'Football', text: 'Football', value: 13},
        {key: 'Vip', text: 'Vip', value: 14},
        {key: 'Showdown', text: 'Showdown', value: 15},
        {key: 'FtueControlPoints', text: 'FtueControlPoints', value: 308},
    ];
    const sessionPhases = [
        {key: 'All', text: 'All', value: "All"},
        {key: 'Fillup', text: 'Fillup', value: "Fillup"},
        {key: 'Allocating', text: 'Allocating', value: "Allocating"},
        {key: 'Loading', text: 'Loading', value: "Loading"},
        {key: 'Playing', text: 'Playing', value: "Playing"},
    ];
    const [playerConnections, setPlayerConnections] = useState([]);
    const [serverConnections, setServerConnections] = useState([]);
    const [servers, setServers] = useState([]);
    const [sessions, setSessions] = useState([]);
    const [playerQueue, setPlayerQueue] = useState([]);
    const [profilingData, setProfilingData] = useState([]);
    const [error, setError] = useState(null);
    const [resetNotification, setResetNotification] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showTimeOutModal, setShowTimeOutModal] = useState(false);
    const [sessionExpanded, setSessionExpanded] = useState([]);
    const [serverExpanded, setServerExpanded] = useState([]);
    const [socketConnected, setSocketConnected] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const socketRef = useRef(null);

    const [showIrrelevantServers, setShowIrrelevantServers] = useState(false)
    const [showIrrelevantSessions, setShowIrrelevantSessions] = useState(false)

    const currentDomain = window.location.origin.replace(/:\d+$/, ':8080');
    const currentSocketDomain = currentDomain.replace(/^http/, 'ws')
    const connectURL = `${currentSocketDomain}/v1/mm/admin/connect`;
    const [selectedGameModeForServer, setSelectedGameModeForServer] = useState(-1);
    const [selectedGameModeForSession, setSelectedGameModeForSession] = useState(-1);
    const [selectedPhaseForSession, setSelectedPhaseForSession] = useState('All');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const [configFileData, setConfigFileData] = useState({});
    const displayConfigFile = (data) => {
        setConfigFileData(data)
        openModal()
    }

    const handleGameModeChangeForServer = (e, {value}) => {
        setSelectedGameModeForServer(value);
    };

    const handleGameModeChangeForSession = (e, {value}) => {
        setSelectedGameModeForSession(value);
    }

    const handlePhaseChangeForSession = (e, {value}) => {
        setSelectedPhaseForSession(value);
    }
    const handleDeleteConfig = () => {
        setShowDeleteConfirm(true);
    };

    const handleConfirmDelete = () => {
        // Check if socketRef is valid before using
        if (socketRef.current) {
            // Call the delete logic here
            const resetRequest = {
                type: "ResetState",
                adminID: "placeholder"
            };

            var data = JSON.stringify(resetRequest)
            socketRef.current.send(data);

            console.log("Sent" + resetRequest);

            setShowDeleteConfirm(false);
        } else {
            console.error("Socket reference is not valid");
        }
    };

    const handleCancelDelete = () => {
        setShowDeleteConfirm(false);
    };

    const handleStartServer = (instanceID) => {
        if (socketRef.current) {
            const startServerRequest = {
                type: "StartServer",
                instanceID: instanceID,
            }

            var data = JSON.stringify(startServerRequest)
            socketRef.current.send(data);

            console.log("Sent" + startServerRequest);
        }
    }

    const handleGetConfigFile = () => {
        if (socketRef.current) {
            const getConfigFileRequest = {
                type: "GetCfgFile",
                adminID: "placeholder"
            }

            var data = JSON.stringify(getConfigFileRequest)
            socketRef.current.send(data);

            console.log("Sent" + getConfigFileRequest);
        }
    }

    const handleKillServer = (instanceID) => {
        if (socketRef.current) {
            const killServerRequest = {
                type: "KillServer",
                instanceID: instanceID,
            }

            var data = JSON.stringify(killServerRequest)
            socketRef.current.send(data);

            console.log("Sent" + killServerRequest);
        }
    }

    // const newConfigRef = useRef(null); // Create a ref for the newConfig state

    useEffect(() => {

        const currentDomain = window.location.origin;
        console.log(currentDomain);

        handleWebSocket();

        // Check socket connection status periodically
        const interval = setInterval(() => {
            setSocketConnected(socketRef.current && socketRef.current.readyState === WebSocket.OPEN);
        }, 100); // Check every 0.1 second

        return () => {
            socketRef.current.close();
            clearInterval(interval);
        };
    }, []);

    const displayProfilingData = (profilingData) => {
        return (
            <div>
                {Object.entries(profilingData).map(([key, value]) => (
                    <p key={key}>{key} : {value}ms</p>
                ))}
            </div>
        );
    }

    // Declare the socket variable outside the handleWebSocket function

    const handleWebSocket = () => {
        // console.log("socket uRL :" + connectURL)
        socketRef.current = new WebSocket(connectURL); // Replace with your actual WebSocket URL

        console.log("Register");

        socketRef.current.onopen = () => {
            console.log('WebSocket connection established.');
            tryFetchAdminConfig()
        };

        socketRef.current.onmessage = (event) => {
            //purposefully added replacement with regex to handle large numbers. this simply replaces number with 17 or more digits with a string
            const msg = JSON.parse(event.data.replace(/("[^"]*"\s*:\s*)(\d{17,})/g, '$1"$2"'));

            switch (msg.type) {
                case "AdminStream":
                    setServers(msg.servers)
                    setPlayerConnections(msg.playerConnections)
                    setServerConnections(msg.serverConnections)
                    setSessions(msg.sessions)
                    setPlayerQueue(msg.playersQueue)
                    break;
                case "ProfilingData":
                    setProfilingData(msg.profilingData)
                    break;
                case "CfgInfo":
                    setAdminCfg(msg.currCfg)
                    console.log("Received new cfg." + JSON.stringify(msg.currCfg))
                    break;
                case "CfgFileInfo":
                    //display the json config in new tab
                    displayConfigFile(msg.config)
                    break;
                case "UpdateConfigDone":
                    console.log("Received confirmation for update cfg success.")
                    if (msg.success) {
                        setSuccessMessage('Session config updated successfully!'); // Set the success message
                        setShowSuccessModal(true); // Show the success modal
                    } else {
                        setError('Session config could not be updated. Check server logs for more details!');
                        setShowErrorModal(true);
                    }
                    break;
                case "ResetDone":
                    setResetNotification(true); // Show the reset notification
                    setTimeout(() => {
                        setResetNotification(false); // Hide the reset notification after 5 seconds
                    }, 3000); // 5
                    break;
                case "BadRequest":
                    setError("Received error code " + msg.statusCode + ": " + msg.message)
                    setShowErrorModal(true)
                    setTimeout(() => {
                        setShowErrorModal(false)
                    }, 3000);
                    break;
                case "TimeOut":
                    setShowTimeOutModal(true)
                    break;
                default:
                    console.log("Received invalid msg type " + msg.type)
            }
        };

        return () => {
            socketRef.current.close();
        };
    };

    const tryFetchAdminConfig = () => {
        if (socketRef.current) {

            const getCfgRequest = {
                type: "GetCfg",
                adminID: "placeholder"
            }

            var data = JSON.stringify(getCfgRequest)
            socketRef.current.send(data);

            console.log("Sent" + getCfgRequest);

        } else {
            console.error("Socket reference is not valid");
        }
    };

// $roots keeps previous parent properties as they will be added as a prefix for each prop.
// $sep is just a preference if you want to seperate nested paths other than dot.
    const flatten = (obj, roots = [], sep = '.') => {
        if (obj === null || obj === undefined) return {};

        return Object
            .keys(obj)
            .reduce((memo, prop) => Object.assign(
                {},
                memo,
                Array.isArray(obj[prop])
                    ? obj[prop].reduce((itemMemo, item, index) => Object.assign(
                        {},
                        itemMemo,
                        typeof item === 'object'
                            ? flatten(item, roots.concat([prop, index]), sep)
                            : {[roots.concat([prop, index]).join(sep)]: item}
                    ), {})
                    : typeof obj[prop] === 'object'
                        ? flatten(obj[prop], roots.concat([prop]), sep)
                        : {[roots.concat([prop]).join(sep)]: obj[prop]}
            ), {});
    }

    function unflatten(data, sep = '.') {
        var result = {};
        for (var i in data) {
            var keys = i.split(sep);
            keys.reduce(function (r, e, j) {
                return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 == j ? data[i] : {}) : [])
            }, result);
        }
        return result;
    }


    const handleInputChange = (e, {name, value}) => {
        console.log(`Name: ${name}, Value: ${value}`);
        console.log(JSON.stringify(adminCfg));

        setAdminCfg(prevState => {
            const updatedCoreCfg = {
                ...prevState.core,
                [name]: +value
            }

            const updatedPlayerQueueCfg = {
                ...prevState.playerQueueCfg,
                [name]: +value
            }

            const updatedModeCfg = flatten(prevState.modeCfg);
            if (name in updatedModeCfg) {
                updatedModeCfg[name] = typeof value === 'boolean' ? value : +value;
            }
            const unflattenedModeCfg = unflatten(updatedModeCfg);

            console.log("*********unflatten: ", unflattenedModeCfg);
            return {
                ...prevState,
                core: updatedCoreCfg,
                playerQueueCfg: updatedPlayerQueueCfg,
                modeCfg: unflattenedModeCfg,
            };
        });
    };

    const tryHandleUpdateConfig = () => {
        if (socketRef.current) {

            const updateCfgRequest = {
                type: "UpdateCfg",
                adminID: "placeholder",
                newCfg: adminCfg,
            }

            var data = JSON.stringify(updateCfgRequest)
            socketRef.current.send(data);

            console.log("Sent" + data);

        } else {
            console.error("Socket reference is not valid");
        }
    };

    // Function to get the strings need for team size
    function getTeamSizeDescription(teamSize) {
        switch (teamSize) {
            case '1':
            case 1:
                return 'Solos';
            case '2':
            case 2:
                return 'Duos';
            case '4':
            case 4:
                return 'Squads';
            default:
                return 'Unknown';
        }
    }

    function getServerCurrentSessionTime(server) {
        if (server.phase === 'Ready') {
            return Math.round((Date.now() - new Date(server.readyStartTime)) / 1000) + " secs";
        } else if (server.phase === 'Allocated') {
            return Math.round((Date.now() - new Date(server.allocatedStartTime)) / 1000) + " secs";
        } else if (server.phase === 'Playing') {
            return Math.round((Date.now() - new Date(server.playingStartTime)) / 1000) + " secs";
        } else if (server.phase === 'Expired') {
            return Math.round((Date.now() - new Date(server.expiredStartTime)) / 1000) + " secs";
        } else {
            return "";
        }
    }

    // Function to get the total players in the queue
    function getActualPlayerCount(players) {
        let count = 0;
        for (let i = 0; i < players.length; i++) {
            if (players[i] && players[i].partyInfo && players[i].partyInfo.teamMates) {
                count += players[i].partyInfo.teamMates.length + 1; // Add 1 for the leader
            }
        }
        return count;
    }

    function getConfig(gameMode, teamSize) {
        // Change to use consts similar to go backend
        switch (gameMode) {
            case 0:
                switch (teamSize) {
                    case 1:
                        return adminCfg.modeCfg.fullBR.solo;
                    case 2:
                        return adminCfg.modeCfg.fullBR.duo;
                    case 4:
                        return adminCfg.modeCfg.fullBR.quad;
                    default:
                        return {error: 'Invalid team size for FullBR'};
                }
            case 1:
                switch (teamSize) {
                    case 1:
                        return adminCfg.modeCfg.miniBR.solo;
                    case 2:
                        return adminCfg.modeCfg.miniBR.duo;
                    case 4:
                        return adminCfg.modeCfg.miniBR.quad;
                    default:
                        return {error: 'Invalid team size for MiniBR'};
                }
            case 2:
                switch (teamSize) {
                    case 1:
                        return adminCfg.modeCfg.tutorialBR.solo;
                    case 2:
                        return adminCfg.modeCfg.tutorialBR.duo;
                    case 4:
                        return adminCfg.modeCfg.tutorialBR.quad;
                    default:
                        return {error: 'Invalid team size for TutorialBR'};
                }
            case 3:
                switch (teamSize) {
                    case 4:
                        return adminCfg.modeCfg.tdm.quad;
                    default:
                        return {error: 'Invalid team size for TDM'};
                }
            case 4:
                switch (teamSize) {
                    case 2:
                        return adminCfg.modeCfg.miniTDM.duo;
                    default:
                        return {error: 'Invalid team size for Mini TDM'};
                }
            case 9:
                switch (teamSize) {
                    case 1:
                        return adminCfg.modeCfg.lowGravity.solo;
                    default:
                        return {error: 'Invalid team size for Low Gravity'};
                }
            case 10:
                switch (teamSize) {
                    case 1:
                        return adminCfg.modeCfg.deadeyeDM.solo;
                    default:
                        return {error: 'Invalid team size for Deadeye DM'};
                }
            case 11:
                switch (teamSize) {
                    case 4:
                        return adminCfg.modeCfg.controlPoints.quad;
                    default:
                        return {error: 'Invalid team size for Control Points'};
                }
            case 12:
                    switch (teamSize) {
                        case 1:
                            return adminCfg.modeCfg.gunGame.solo;
                        default:
                            return {error: 'Invalid team size for GunGame'};
                    }
            case 13:
                switch (teamSize) {
                    case 4:
                        return adminCfg.modeCfg.football.quad;
                    default:
                        return {error: 'Invalid team size for Football'};
                }
            case 14:
                switch (teamSize) {
                    case 4:
                        return adminCfg.modeCfg.vip.quad;
                    default:
                        return {error: 'Invalid team size for VIP'};
                }
            case 15:
                switch (teamSize) {
                    case 1:
                        return adminCfg.modeCfg.showdown.solo;
                    default:
                        return {error: 'Invalid team size for Showdown'};
                }
            case 308:
                switch (teamSize) {
                    case 4:
                        return adminCfg.modeCfg.ftueControlPoints.quad;
                    default:
                        return {error: 'Invalid team size for Ftue Control Points'};
                }
            default:
                return {error: 'Invalid game mode'};
        }
    }

    function isLevelMmrEnabled(player) {
        let config = getConfig(player.matchRequest.gameMode, player.matchRequest.teamSize);
        return config.mmrConfig.isMmrEnabled;
    }

    function getPartyMmrLevel(player) {
        let totalPartyPlayers = 1
        if (player.partyInfo.teamMates !== null) {
            totalPartyPlayers = totalPartyPlayers + player.partyInfo.teamMates.length;
        }
        let config = getConfig(player.matchRequest.gameMode, player.matchRequest.teamSize);
        let value = 1 + (totalPartyPlayers) / (config.mmrConfig.controlledValue);
        let partyMmr = (player.level) * value;
        if (player.partyInfo.teamMates !== null) {
            player.partyInfo.teamMates.forEach(teammate => {
                partyMmr += teammate.level * value;
            });
        }
        partyMmr = partyMmr / totalPartyPlayers;
        return parseInt(partyMmr)
    }

    const [activeTab, setActiveTab] = useState(0); // Game Mode Selection, used in ModeConfigWidget

    const handleTabChange = (e, {activeIndex}) => {
        setActiveTab(activeIndex);
    };

    return (

        <Container className="customContainer">
            {resetNotification && (
                <Message
                    onDismiss={() => setResetNotification(false)}
                    header='Reset Result'
                    content='The reset operation has been completed.'
                    positive
                    floating
                />
            )}
            <Header as="h1" className="customHeader">IndusGO | MM Admin v0.1</Header>
            <a href="https://tdm.prod.in.mm.indusgame.com/" style={{marginRight: "10px"}}>IN</a>
            <a href="https://tdm.prod.asia.mm.indusgame.com/" style={{marginRight: "10px"}}>ASIA</a>
            <a href="https://tdm.prod.sa.mm.indusgame.com/" style={{marginRight: "10px"}}>SA</a>
            <a href="https://tdm.prod.eu.mm.indusgame.com/" style={{marginRight: "10px"}}>EU</a>
            <a href="https://tdm.prod.na.mm.indusgame.com/" style={{marginRight: "10px"}}>NA</a>
            <a href="https://tdm.prod-brx.sa.mm.indusgame.com/" style={{marginRight: "10px"}}>PR-SA</a>
            <a href="https://tdm.prod-primerush.mena.mm.indusgame.com/" style={{marginRight: "10px"}}>PR-MENA</a>
            <a href="https://tdm.prod-brx.mx.mm.indusgame.com/">PR-MX</a>
            <Segment>
                <Header as="h3">Service Status</Header>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <div style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: socketConnected ? 'green' : 'red',
                            marginRight: '5px'
                        }}></div>
                        <span>{socketConnected ? 'Connected' : 'Disconnected!'}</span>
                    </div>
                    <Label color='teal' tag>{`Version ${appVersion}`}</Label>
                </div>
            </Segment>

            <Grid columns={4} stackable>
                <Grid.Column>

                    {/*<Button title="Click to update the configuration" type="button" onClick={tryHandleUpdateConfig}>Update
                        Config</Button>

                    <br/>*/}
                    <Button title="Click to get the configuration file" type="button" onClick={handleGetConfigFile}>
                        Get Region File</Button>
                    {isModalOpen && (
                        <div className="modal-overlay">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h2>Configuration</h2>
                                    <button className="modal-close" onClick={closeModal}>
                                        ✖
                                    </button>
                                </div>
                                <ConfigPage
                                    config={configFileData}
                                />
                            </div>
                        </div>
                    )}

                    <Segment style={{overflow: 'auto', maxHeight: 600}}>
                        <Header as="h3">Configurations</Header>
                        {adminCfg && (
                            <Form>
                                <Segment>
                                    <Header as="h4">Core</Header>
                                    <Form.Field>
                                        <label>Eval Tick Interval:</label>
                                        <Input
                                            title="Tick interval at which MM is processed"
                                            type="number"
                                            name="evalTickInterval"
                                            value={adminCfg.core.evalTickInterval}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Field>
                                </Segment>
                                <Segment>
                                    <Header as="h4">Player Queues</Header>
                                    <Form.Field>
                                        <label>Processing Batch Size:</label>
                                        <Input
                                            title="Minium players in queue after which session creation can start happening"
                                            type="number"
                                            name="queueProcessBatchSize"
                                            value={adminCfg.playerQueueCfg.queueProcessBatchSize}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Queue TimeOut:</label>
                                        <Input
                                            title="Disconnect a player after this long in the queue"
                                            type="number"
                                            name="queueTimeOut"
                                            value={adminCfg.playerQueueCfg.queueTimeOut}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Field>
                                </Segment>
                                <div>
                                    <ModeConfigWidget adminCfg={adminCfg} handleInputChange={handleInputChange}
                                                      handleTabChange={handleTabChange} activeTab={activeTab}/>
                                </div>
                            </Form>
                        )}
                    </Segment>
                    <Segment style={{overflow: 'auto', maxHeight: 600}}>
                        <Header as="h3">Profiling Data</Header>
                        {profilingData && displayProfilingData(profilingData)}
                    </Segment>
                </Grid.Column>
                <Grid.Column>
                    <Segment>
                        <Header as='h3'>Connections ({playerConnections?.length + serverConnections?.length})</Header>
                        <ul>
                            <Header as='h4'>Players ({playerConnections?.length})</Header>
                            {playerConnections.length > 0 && (
                                playerConnections.sort((a, b) => a.id.localeCompare(b.id)).map((connection, index) => (
                                    <li key={index}>{connection.friendlyName} [{connection.id}]</li>
                                ))
                            )}
                            <Header as='h4'>Servers ({serverConnections?.length})</Header>
                            {serverConnections.length > 0 && (
                                serverConnections.sort((a, b) => a.id.localeCompare(b.id)).map((connection, index) => (
                                    <li key={index}>{connection.friendlyName} [{connection.id}]</li>
                                ))
                            )}
                        </ul>
                    </Segment>
                    <Segment>
                        <Header as='h3'>Player Queue</Header>
                        {playerQueue ? (
                            Object.keys(playerQueue).map((teamSize, index) => (
                                <Segment key={index}>
                                    <Header as='h4'>
                                        {getTeamSizeDescription(teamSize)} ({playerQueue[teamSize]?.players?.length})
                                    </Header>
                                    {teamSize > 1 && (
                                        <div>
                                            Player Count: {getActualPlayerCount(playerQueue[teamSize]?.players)}
                                        </div>
                                    )}
                                    {teamSize > 1 && (
                                        <br/>
                                    )}
                                    <ul>
                                        {playerQueue[teamSize].players.sort((a, b) => a.partyInfo.partyID - b.partyInfo.partyID).map((player, playerIndex) => (
                                            <li key={playerIndex}>
                                                [prty: {player.partyInfo.partyID}]
                                                <br/>
                                                <ul>
                                                    <li>
                                                        <b>[{"\u2713"}] <u>{player.userName}</u></b> [{player.userID}]
                                                    </li>
                                                </ul>
                                                {player.partyInfo.teamMates && (
                                                    <ul>
                                                        {player.partyInfo.teamMates.map((teammate, teammateIndex) => (
                                                            <li key={teammateIndex}>
                                                                <b>[{teammate.isReady ? "\u2713" : " "}] {teammate.userName}</b> [{teammate.userID}]
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </Segment>
                            ))
                        ) : (
                            <p>No players in the matchmaking queue</p>
                        )}
                    </Segment>
                </Grid.Column>
                <Grid.Column>
                    <Segment>
                        <Header as='h3'>Servers By Phases</Header>
                        <Dropdown
                            placeholder='Select Game Mode'
                            fluid
                            selection
                            options={gameModes}
                            onChange={handleGameModeChangeForServer}
                            value={selectedGameModeForServer}
                        />
                        {selectedGameModeForServer !== -1 ? (
                            <ul>
                                <li>Ready: {servers.filter(server => (server.phase === 'Ready' && server.gameMode === selectedGameModeForServer)).length}</li>
                                <li>Allocated: {servers.filter(server => (server.phase === 'Allocated' && server.gameMode === selectedGameModeForServer)).length}</li>
                                <li>Playing: {servers.filter(server => (server.phase === 'Playing' && server.gameMode === selectedGameModeForServer)).length}</li>
                            </ul>
                        ) : (
                            <ul>
                                <li>Ready: {servers.filter(server => server.phase === 'Ready').length}</li>
                                <li>Allocated: {servers.filter(server => server.phase === 'Allocated').length}</li>
                                <li>Playing: {servers.filter(server => server.phase === 'Playing').length}</li>
                            </ul>
                        )}
                    </Segment>
                    <Segment>
                        <Header as='h3'>Servers ({servers?.length})</Header>
                        <Form>
                            <Form.Field>
                                <Checkbox
                                    toggle
                                    label='Show Irrelevant Servers'
                                    checked={showIrrelevantServers}
                                    onChange={() => setShowIrrelevantServers(!showIrrelevantServers)}
                                />
                            </Form.Field>
                        </Form>
                        {servers && (
                            servers.filter(server => showIrrelevantServers || (server.phase !== 'Irrelevant')).sort((a, b) => a.instanceID.localeCompare(b.instanceID)).map((server, index) => {
                                // console.log('Mapping session:', session); // Add this line for debugging
                                const isExpanded = serverExpanded.includes(server.instanceID);
                                const toggleExpand = () => {
                                    if (isExpanded) {
                                        setServerExpanded(serverExpanded.filter(id => id !== server.instanceID));
                                    } else {
                                        setServerExpanded([...serverExpanded, server.instanceID]);
                                    }
                                };
                                return (
                                    <Segment key={index} style={{
                                        backgroundColor:
                                            server.phase === 'Ready' ? 'lightyellow' :
                                                server.phase === 'Allocated' ? 'lightblue' :
                                                    server.phase === 'Playing' ? 'lightgreen' :
                                                        server.phase === 'Expired' ? 'lightpink' :
                                                            server.phase === 'Irrelevant' ? 'lightgrey' :
                                                                'inherit',
                                        boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', // Add drop shadow effect
                                        transition: '0.3s'
                                    }} onClick={toggleExpand}>
                                        <p>Instance ID: {server.instanceID}</p>
                                        <p>Match ID: {server.matchID}</p>
                                        <p>Session ID: {server.sessionID}</p>
                                        <p>Player Count: {server.playerCount}</p>
                                        <p>Version: {server.version}</p>
                                        <p>Team Type: {getTeamSizeDescription(server.teamSize)}</p>
                                        <p>Game Mode: {server.gameMode}</p>
                                        <p>Region: {server.region}</p>
                                        <p>Map Name: {server.mapName}</p>
                                        <p>Phase: {server.phase} ({getServerCurrentSessionTime(server)})</p>
                                        <p>Server Type: {server.serverType}</p>
                                        <p>Remaining Time: {server.remainingGameTime}</p>
                                        <p>Current Score: {server.currentScore}</p>
                                        <p>Room ID: {server.roomID}</p>
                                        <p>Emulator: {server.isEmulator ? "True" : "False"}</p>
                                        {isExpanded && (
                                            <div>
                                                <ul>
                                                    {server.squads && (
                                                        server.squads.map((squad, squadIndex) => (
                                                            <li key={squadIndex}>
                                                                Squad {squadIndex} {squad.autoFilled ? "[Auto Filled]" : ""}
                                                                <ul>
                                                                    {squad.members && squad.members.sort((a, b) => a.id - b.id).map((member, memberIndex) => (
                                                                        <li key={memberIndex}>
                                                                            <b>{member.name}</b> [{member.id}]
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </li>
                                                        ))
                                                    )}
                                                </ul>
                                            </div>
                                        )}
                                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                            {(server.phase === 'Allocated')
                                                && (<Button
                                                    title="Click to start the server!"
                                                    type="button"
                                                    onClick={() => handleStartServer(server.instanceID)}
                                                    color="green">
                                                    Start
                                                </Button>)}
                                            {(server.phase === 'Ready' || server.phase === 'Allocated')
                                                && (<Button
                                                    title="Click to kill the server!"
                                                    type="button"
                                                    onClick={() => handleKillServer(server.instanceID)}
                                                    color="red">
                                                    Kill
                                                </Button>)}
                                        </div>
                                    </Segment>
                                )
                            })
                        )}
                    </Segment>
                </Grid.Column>
                <Grid.Column>
                    <Segment>
                        <Header as='h3'>Sessions By Phases</Header>
                        <Dropdown
                            placeholder='Select Game Mode'
                            fluid
                            selection
                            options={gameModes}
                            onChange={handleGameModeChangeForSession}
                            value={selectedGameModeForSession}
                        />
                        {selectedGameModeForSession !== -1 ? (
                            <ul>
                                <li>Fillup: {sessions.filter(session => (session.phase === 'Fillup' && session.matchRequest.gameMode === selectedGameModeForSession)).length}</li>
                                <li>Allocating: {sessions.filter(session => (session.phase === 'Allocating' && session.matchRequest.gameMode === selectedGameModeForSession)).length}</li>
                                <li>Loading: {sessions.filter(session => (session.phase === 'Loading' && session.matchRequest.gameMode === selectedGameModeForSession)).length}</li>
                                <li>Playing: {sessions.filter(session => (session.phase === 'Playing' && session.matchRequest.gameMode === selectedGameModeForSession)).length}</li>
                            </ul>
                        ) : (
                            <ul>
                                <li>Fillup: {sessions.filter(session => session.phase === 'Fillup').length}</li>
                                <li>Allocating: {sessions.filter(session => session.phase === 'Allocating').length}</li>
                                <li>Loading: {sessions.filter(session => session.phase === 'Loading').length}</li>
                                <li>Playing: {sessions.filter(session => session.phase === 'Playing').length}</li>
                            </ul>
                        )}
                    </Segment>
                    <Segment>
                        <Header as="h3">Sessions
                            ({selectedPhaseForSession === "All" ? sessions.length : sessions.filter(session => session.phase === selectedPhaseForSession).length})</Header>
                        <Form>
                            <Form.Field>
                                <Checkbox
                                    toggle
                                    label='Show Irrelevant Sessions'
                                    checked={showIrrelevantSessions}
                                    onChange={() => setShowIrrelevantSessions(!showIrrelevantSessions)}
                                />
                            </Form.Field>
                            <Dropdown
                                placeholder='Select Session Phase'
                                fluid
                                selection
                                options={sessionPhases}
                                onChange={handlePhaseChangeForSession}
                                value={selectedPhaseForSession}
                            />
                        </Form>
                        {sessions && (
                            sessions.filter(session => selectedPhaseForSession === "All" || showIrrelevantSessions || (session.phase !== 'Irrelevant' && session.phase === selectedPhaseForSession)).sort((a, b) => a.id.localeCompare(b.id)).map((session, index) => {
                                // console.log('Mapping session:', session); // Add this line for debugging
                                const isExpanded = sessionExpanded.includes(session.id);
                                const toggleExpand = () => {
                                    if (isExpanded) {
                                        setSessionExpanded(sessionExpanded.filter(id => id !== session.id));
                                    } else {
                                        setSessionExpanded([...sessionExpanded, session.id]);
                                    }
                                };
                                return (
                                    <Segment key={index} style={{
                                        backgroundColor:
                                            session.phase === 'Fillup' ? 'lightyellow' :
                                                session.phase === 'Allocating' ? 'lightyellow' :
                                                    session.phase === 'Loading' ? 'lightblue' :
                                                        session.phase === 'Playing' ? 'lightgreen' :
                                                            session.phase === 'Expired' ? 'lightpink' :
                                                                session.phase === 'Irrelevant' ? 'lightgrey' :
                                                                    'inherit',
                                        boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', // Add drop shadow effect
                                        transition: '0.3s'
                                    }} onClick={toggleExpand}>
                                        <p>Session ID: {session.id}</p>
                                        <p>Room ID: {session.roomID}</p>
                                        <p>Version: {session.envInfo.version}</p>
                                        <p>Phase: {session.phase} ({(
                                            session.phase === 'Fillup'
                                                ? Math.round((Date.now() - new Date(session.fillupStartTime)) / 1000) + " secs"
                                                : session.phase === 'Allocating'
                                                    ? Math.round((Date.now() - new Date(session.allocatingStartTime)) / 1000) + " secs"
                                                    : ""
                                        )})</p>
                                        <p>Team Type: {getTeamSizeDescription(session.matchRequest.teamSize)}</p>
                                        <p>Game Mode: {session.matchRequest.gameMode}</p>
                                        <p>Map Name: {session.matchRequest.mapName}</p>
                                        {session.minMmr !== -1 && <p>Min MMR: {session.minMmr}</p>}
                                        {session.maxMmr !== -1 && <p>Max MMR: {session.maxMmr}</p>}
                                        <p>Emulator: {session.isEmulator ? "True" : "False"}</p>
                                        {isExpanded && (
                                            <div>
                                                <p>Parties: ({session?.players?.length}) / Players:
                                                    ({getActualPlayerCount(session?.players)}):</p>
                                                <ul>
                                                    {session.players.sort((a, b) => a.partyInfo.partyID - b.partyInfo.partyID).map((player, playerIndex) => (
                                                        <li key={playerIndex}>
                                                            [prty: {player.partyInfo.partyID}] {player.partyInfo.allowStrangers ? "[Allow Strangers]" : ""} {isLevelMmrEnabled(player) ? "[Party MMR: " + getPartyMmrLevel(player) + "]" : ""}
                                                            <br/>
                                                            <ul>
                                                                <li>
                                                                    <b>[{"\u2713"}] <u>{player.userName}</u></b> [{player.userID}]
                                                                    [Level:{player.level}]
                                                                </li>
                                                            </ul>
                                                            {player.partyInfo.teamMates && (
                                                                <ul>
                                                                    {player.partyInfo.teamMates.map((teammate, teammateIndex) => (
                                                                        <li key={teammateIndex}>
                                                                            <b>[{teammate.isReady ? "\u2713" : " "}] {teammate.userName}</b> [{teammate.userID}]
                                                                            [Level:{teammate.level}]
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </li>
                                                    ))}
                                                </ul>
                                                {session.squads?.map((squad, index) => (
                                                    <div key={index}>
                                                        <li>Squad {index}
                                                            <ul>
                                                                {squad?.members?.map((member, mIndex) => (
                                                                    <li key={mIndex}>{member.id}</li>
                                                                ))}
                                                            </ul>
                                                        </li>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </Segment>
                                );
                            })
                        )}
                    </Segment>
                </Grid.Column>
            </Grid>
            <Modal
                open={showErrorModal}
                onClose={() => setShowErrorModal(false)}
                size='mini'
            >
                <Modal.Header>Error!</Modal.Header>
                <Modal.Content>
                    <p>{error}</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button negative onClick={() => setShowErrorModal(false)}>Close</Button>
                </Modal.Actions>
            </Modal>
            <Modal
                open={showSuccessModal}
                onClose={() => setShowSuccessModal(false)}
                size='mini'
            >
                <Modal.Header>Success</Modal.Header>
                <Modal.Content>
                    <p>{successMessage}</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button positive onClick={() => setShowSuccessModal(false)}>Close</Button>
                </Modal.Actions>
            </Modal>
            <Modal
                open={showTimeOutModal}
                size='mini'
            >
                <Modal.Header>TimeOut!</Modal.Header>
                <Modal.Content>
                    <p>Admin connection timeout - please refresh using <b>(Ctrl/Cmd)+(Shift)+(R)</b>.</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button negative onClick={window.location.reload}>OK</Button>
                </Modal.Actions>
            </Modal>
            <div>
                {/* Other components */}
                <br/>
                <Confirm
                    open={showDeleteConfirm}
                    onCancel={handleCancelDelete}
                    onConfirm={handleConfirmDelete}
                    content="Are you sure you want wipe the internal state of the match maker? This will immediately reset all the sessions and queues!"
                    style={{maxWidth: '400px'}}
                />
            </div>
        </Container>

    );
}

export default App;